interface Props {
  // Height of the sticky toolbar above the grid (StickyBar reports it).
  stickyOffset: number;
  // Rendered height of the grid's thead.
  theadHeight: number;
}

// Opaque panel pinned behind the sticky toolbar + header rows. Zero layout
// footprint (negative margins cancel its height and align it over the
// toolbar + thead, not the body rows); z-20 sits above scrolling body content
// but below the sticky header cells (same z-20, later in DOM), so nothing
// shows through paint seams in the header stack.
export default function StickyHeaderBackdrop({ stickyOffset, theadHeight }: Props) {
  return (
    <div
      aria-hidden
      className="sticky z-20"
      style={{
        top: 0,
        height: stickyOffset + theadHeight,
        marginTop: -stickyOffset,
        marginBottom: -theadHeight,
        background: "var(--background)",
      }}
    />
  );
}
